define.alias("shared/components/shared/upgrade/mobile-plan-card", "settings/components/shared/upgrade/mobile-plan-card");